module.exports = "/virtual-football-league/img/amblems/right/logos/StrokeCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/StrokeCity.png
// module id = 2230
// module chunks = 4